import { render, staticRenderFns } from "./NTab.vue?vue&type=template&id=2c61829c&scoped=true"
import script from "./NTab.vue?vue&type=script&lang=js"
export * from "./NTab.vue?vue&type=script&lang=js"
import style0 from "./NTab.vue?vue&type=style&index=0&id=2c61829c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61829c",
  null
  
)

export default component.exports